import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from "@tanstack/react-query";
import { AxiosError } from "axios";

import { commonQueryKeys } from "@/common/data/commonQueryKeys";
import api from "@/common/utils/api";
import { ErrorResponse } from "@reflag/shared/api";
import { AppDTO, CreateAppArgsType } from "@reflag/shared/appAPI";

export function useCreateAppMutation(
  orgId?: string,
  {
    onSuccess,
    ...options
  }: Omit<
    UseMutationOptions<
      AppDTO,
      AxiosError<ErrorResponse>,
      Omit<CreateAppArgsType, "orgId">
    >,
    "mutationKey" | "mutationFn"
  > = {},
) {
  const queryClient = useQueryClient();

  return useMutation<
    AppDTO,
    AxiosError<ErrorResponse>,
    Omit<CreateAppArgsType, "orgId">
  >({
    mutationFn: (params) =>
      api
        .post<"/apps">(`/apps`, { ...params, orgId: orgId! })
        .then((res) => res.data),
    onSuccess: async (data, variables, context) => {
      await queryClient.invalidateQueries(
        {
          queryKey: commonQueryKeys.bootstrap(orgId),
        },
        {
          throwOnError: true,
        },
      );
      onSuccess?.(data, variables, context);
    },
    ...options,
  });
}
